import type {
  ProjectRevenueSummaryQuery,
  ProjectRevenueTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";
import { ProjectReportStore } from "../../common/store";
import { ProjectRevenueModel } from "../models";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "projectRevenue";
  reportStore: ProjectReportStore;
  @observable.ref projects: ProjectRevenueModel[] = [];
  @observable
  summary?: ProjectRevenueSummaryQuery["projectRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new ProjectReportStore(this.key);
  }

  @action setTableData(query: ProjectRevenueTableDataQuery) {
    this.projects = query.projectRevenue.projects.map(
      (i) => new ProjectRevenueModel(i),
    );
    this.reportStore.setExpenseBudgetCategories(
      query.expenseBudgetCategories ?? [],
    );

    if (query.projectRevenue.projects) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.projectRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: ProjectRevenueSummaryQuery) {
    this.summary = query.projectRevenueSummary;
  }
}
